const UserMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.dashboard'
    },
    class_name: 'mb-3',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Reservations',
    is_heading: true,
    is_active: false,
    link: {
      name: 'user.reservations'
    },
    class_name: 'font-weight-bolder'
  },
  {
    title: 'Pending',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.reservations.pending'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-file',
    active_icon: 'fad fa-file'
  },
  {
    title: 'Histories',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.reservations.histories'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-clock-rotate-left',
    active_icon: 'fad fa-clock-rotate-left'
  }
]

export default UserMenu
